import { gql } from '@apollo/client'

export default gql`
  fragment EmployeeTagInfoShort on EmployeeTagInfoShort {
    addedDate
    removedDate
    type
    note
    employeeId
    addedById
    removedById
  }
`
